import React from 'react'
import s from './progress-bar.module.scss'
import classNames from 'classnames'

export const ProgressBar = ({ currentStep, totalSteps, className }) => {

  const step = Math.max(0, Math.min(currentStep, totalSteps))

  return (
    <div className={classNames(s.container, className)}>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isActive = index < step;
        return (
          <div
            key={index}
            className={classNames(s.segment, isActive ? s.active : '')}
          />
        )
      })}
    </div>
  )
}